export default __webpack_public_path__ + "static/media/hangMan.3fcf16a5.png";